(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('portalGroupService', portalGroupService);
    
    function portalGroupService($http, $q, $log, config, tokenService, cgbusyService) {
        var portalUrl = config.portalUrl;

        return {
            getAllGroupsAndFunctions: getAllGroupsAndFunctions,
            getDepartmentsAndFunctions: getDepartmentsAndFunctions,
            getEmployeesForDepartments: getEmployeesForDepartments,
            getFunctions: getFunctions,
            getGroups: getGroups
        };

        function _filterData(arr, searchString) {
            return arr.filter(function (item) {
                if (item.displayName && item.displayName.toLowerCase().includes(searchString.toLowerCase())) {
                    return item;
                }
                if (item.idString) {
                    var idString = item.idString.split('//')[2];
                    if (idString && idString.toLowerCase().includes(searchString.toLowerCase())) {
                        return item;
                    }
                }
            });
        }

        function _groupsToRoles(groups) {
            return _.chain(groups)
                .pluck('roles')
                .flatten()
                .sortBy(function (num) { return num.roleName.toLowerCase(); })
                .uniq('roleId')
                .value();
        }
        
        function _getEmployeesForDepartment(id, searchText) {
            // do not block UI in a typeahead
            return $http.get(portalUrl + "/api/1.0/portalGroupMembers/" + id).then(function (response) {
                return _filterData(response.data, searchText);
            }, function (response) {
                return $q.reject(response.data);
            });
        }

        function _getUserGroups() {
            var req = {
                method: 'GET',
                url: portalUrl + '/api/1.0/departments/'
            };

            return _http(req).then(response => {
                return _.sortBy(response.data, user => { return user.name.toLowerCase(); });
            });
        }

        function _http(req) {
            return cgbusyService.blockUI( // for now this is the best way to use cgbusy: just use it in one place
                tokenService.getToken() // get a token
                    .then(() => $http(req)) // execute the actual request
                    .catch(response => {
                        $log.error('Error:', req, response);
                        return $q.reject(response);
                    }));
        }

        function getAllGroupsAndFunctions() {
            var req = {
                method: 'GET',
                url: portalUrl + '/api/1.0/portalGroup/',
                cache: true,
                params: {
                    withRoles: true,
                    groupType: 'department'
                }
            };

            return _http(req).then(response => { return response.data; });
        }

        function getDepartmentsAndFunctions() {
            return $q.all([
                getGroups(config.settings.user.isAdmin),
                getFunctions()
            ]).then(results => {
                return {
                    departments: _.uniq(results[0], 'id'),
                    functions: _.uniq(results[1], 'roleId')
                };
            });
        }
        
        function getEmployeesForDepartments(departments, searchText) {
            return $q.all(departments.map(departmentId => _getEmployeesForDepartment(departmentId, searchText))).then((data) => {
                return _.chain(data)
                    .flatten()
                    .groupBy(item => { return item.idString; })
                    .map(grouped => {
                        var o = grouped[0];
                        o.username = grouped[0].idString.split('//')[2];
                        return o;
                    })
                    .sortBy(user => { return user.displayName.toLowerCase(); })
                    .value();
            });
        }

        function getFunctions(groupId) {
            var req;

            if (groupId) {
                req = {
                    method: 'GET',
                    url: portalUrl + '/api/1.0/portalGroup/' + groupId,
                    cache: true,
                    params: { withRoles: true }
                };

                return _http(req).then(response => {
                    var groups = [];
                    groups.push(response.data);
                    return _groupsToRoles(groups);
                });
            } else {
                req = {
                    method: 'GET',
                    url: portalUrl + '/api/1.0/portalRole',
                    params: { grouptype: 'department' }
                };

                return _http(req).then(response => {
                    return _.sortBy(response.data, function (item) { return item.roleName.toLowerCase(); });
                });
            }
        }

        function getGroups(allGroups) {
            var req = {
                url: portalUrl + '/api/1.0/portalGroup',
                method: 'GET',
                params: { grouptype: 'department' }
            };

            return _http(req).then(response => {
                return allGroups
                    ? response.data
                    : _.filter(response.data, function (item) { return config.settings.user.departmentIdsWhereManager.includes(item.id) });
            });
        }
    }
})();
